import { CardHeader } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import React from 'react';
import { Title } from 'react-admin';

export default () => (
  <Card>
    <Title title="Gridwise Console" />
    <CardHeader title="Welcome to the Gridwise Admin Console " />
    <CardContent>
      To the left you'll find a number of entities that you can manage and
      maniplulate
    </CardContent>
    <CardContent>More coming soon ...</CardContent>
  </Card>
);



// WEBPACK FOOTER //
// ./src/dashboard.js